<template>
    <b-card no-body class=" avatar-information-content col-md-10 col-12 overflow-hidden">
        <b-row>
            <!-- Imagen y pie de la misma -->
            <b-col class="box-avatar-information item-one" > 
                <b-row>
                    <b-col cols="12" class="parent-avatar mt-4 mb-4">
                        <b-avatar class="avatar-imagen" v-if="propUser.image" :src="this.serverPath+'/'+ this.propUser.image" />
                        <b-avatar v-else :src="require('../../../assets/images/login/avatar.svg')" size="20rem" />
                    </b-col>
                    <b-col cols="12" class="child-avatar-information">
                        <b-col class="cargo-avatar">
                            <img src="@/assets/images/icons/checkbox-circle-line.svg"/> 
                            <h4>Trabajador Activo</h4>  
                        </b-col>
                        <b-col class="d-flex justify-content-center p-0">
                            <a href=""> Desde {{ propUser.created_at | moment(getHumanDate) }} </a>  
                        </b-col>  
                    </b-col>
                </b-row>
            </b-col>
            <!-- end -->
            <!-- Formulario para mostar la informacion -->
            <b-col class="box-avatar-information item-two">
                <b-card-body>
                    <b-card-text>
                        <b-form action="#">
                            <b-row>
                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>Nombre completo</label>
                                        <b-form-input type="text" 
                                            :value="propUser.employee ? cutText(propUser.employee, 17) : null" 
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>
                                
                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>Sexo</label>
                                        <b-form-input type="text" 
                                            :value="validIsNull(propUser.gender)"
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>

                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>ID</label>
                                        <b-form-input type="text" 
                                            :value="propUser.cc" 
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>

                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>Edad</label>
                                        <b-form-input type="text" 
                                            :value="validIsNull(propUser.age)"
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>

                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>Área</label>
                                        <b-form-input type="text" 
                                            :value="propUser.area ? cutText(propUser.area, 17) : null"
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>

                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>Teléfono</label>
                                        <b-form-input type="text" 
                                            :value="validIsNull(propUser.phone)"
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>

                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>Cargo</label>
                                        <b-form-input type="text" 
                                            :value="propUser.charge ? cutText(propUser.charge, 17) : null"
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>

                                <b-col cols="6">
                                    <b-form-group cols="6" class="baseline_box">
                                        <label>Sindicato</label>
                                        <b-form-input type="text" 
                                            :value="propUser.labor_union"
                                            class="form-control" 
                                            disabled 
                                            readonly />
                                    </b-form-group>
                                </b-col>
                            
                            </b-row>
                        </b-form>
                    </b-card-text>
                </b-card-body>
            </b-col>
            <!-- end -->
        </b-row>
    </b-card>
</template>

<script>
import serverConfig from './../../../services/config'
export default {
    name: 'WorkerInforV2',
    props: {
        propUser: {}
    },
    data: () => ({
        serverPath: serverConfig.permisosURL,
    }),
   methods: {
      validIsNull(value) {
        return value ?? 'N/A'
      }
   }
}
</script>

<style lang="scss">
.avatar-information-content {
    max-width: 780px;
    padding: 16px;
}
.avatar-information-content >.row {
    display: flex;
    flex-direction: column;
    gap: 36px;
    margin: 0;
    @media (min-width: 992px) {
        flex-direction: row;
    }
}
.box-avatar-information {
    width: 100%;
    padding: 0;
    @media (min-width: 992px) {
    }
    &.item-one {
        max-width: 195px;
        margin: 0 auto;
    }
}
.avatar-imagen {
    width: 10rem;
    height: 10rem;
    @media (min-width: 992px) {
        width: 168px;
        height: 168px;  
    }
}
.cargo-avatar {
    background: #F6FFED;
    border-radius: 100px;
    display: flex;
    align-items: center;
    padding: 4px 6px;
    width: max-content;
    margin: 0 auto;
    gap: 8px;
}
.baseline_box{
    position: relative;
    margin-top: 8px;
    margin-bottom: 8px;
    /* content/00 */
    background: #FFFFFF;
    /* content/01 */
    border: 1px solid #ECEFF1;
    box-sizing: border-box;
    border-radius: 8px;
    label{
        /* label */
        position:absolute;
        left:4px;
        top:-8px;
        line-height:1;
        font-weight:bold;
        padding:4 6px;
        display:none;
 
        /* label regular */
        font-family: Ubuntu;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */
        display: flex;
        align-items: center;
        /* content/02 */
        color: #B0BEC5;
        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0px 4px;
        padding: 0px 4px;
    }
    input{
        position: static;
        // width: 412px;
        width: 100%;
        height: 28px;
        left: calc(50% - 412px/2);
        top: calc(50% - 28px/2);
        background: #ffffff;
        font: normal normal 300 16px/20px "Ubuntu";
        /* content/03 */
        color: #000000;
        margin: 8px;
        border:0;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:focus, &:active {
            outline: 0;
            border:0;
            appearance: none;
            -moz-appearance: none;
            -webkit-appearance: none;
            box-shadow: none;
        }
    }
}
.form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef00;
}

.card {
    background: #FFFFFF;
    /* content/02 */
    border: 1px solid #CFD8DC;
    border-radius: 8px;
}

.parent-avatar {
    height: 70%;
    align-items: center;
    text-align: center;
    padding: 0;
    font: normal normal 400 16px/28px 'Ubuntu';
    color: #263238;
}

.child-avatar-information {
    width: 82%;
    img {
        width: 20px;
        height: 20px;
        background: rgba(255, 255, 255, 0.001);

        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 0;
    }
    h4 {
        color: #00761A;
        margin: 0;
    }
    a {
        cursor: auto; 
        color: black;
        font-weight: 400;
        font-size: 15px;
        line-height: 28px;
    }
    
}
</style>
